import { render, staticRenderFns } from "./CalendarAbout.Dialog.vue?vue&type=template&id=1b2abeb8&scoped=true&"
import script from "./CalendarAbout.Dialog.vue?vue&type=script&lang=js&"
export * from "./CalendarAbout.Dialog.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAbout.Dialog.vue?vue&type=style&index=0&id=1b2abeb8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2abeb8",
  null
  
)

export default component.exports